/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { get, find } from 'lodash';

/**
 * Internal dependencies
 */
import Card from 'components/card';
import { requestPlansIfNotRequested } from 'state/roam-plans/actions';
import { getAllRoamPlans, requestingRoamPlans } from 'state/roam-plans/selectors';
import { swapSubscription } from 'state/subscriptions/actions';
import { getCurrentRoamId, getCurrentRoamPlanId, getCurrentRoam } from 'state/current-roam/selectors';
import { successNotice } from 'state/notices/actions';
import { requestAddonsIfNotRequested } from 'state/addons/actions';
import Loader from './loader';
import { getAllAddons } from 'state/addons/selectors';
import Plan from './plan';
import Preloader from 'components/preloader';
import cscom from 'lib/customer-site-api';
import cb from 'lib/chargebee';
import Money from 'components/money';
import ConfirmNewPlanAlert from './confirm-new-plan-alert'; // Import
import { requestCurrentRoam } from 'state/current-roam/actions';
import { getCurrentUser } from 'state/current-user/selectors';
import { requestCouponsIfNotRequested } from 'state/coupons/actions';
import { Box, Stack } from '@towersystems/towersystems-design-system';
import FlashMessage from 'components/flash-message';
import page from 'page';

/**
 * Style dependencies
 */
import './styles.scss';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const SelectRoamPlan = (props) => {
    const roamPlans = props.roamPlans;
    const [submitting, setSubmitting] = useState(false);
    const [values, setValues] = useState({});

    const onChange = (value) => {
        //if (!props.roamSubscriptionId) {
            return newPlanSubscription(value);
        //}

        let plan = find(roamPlans, { id: value });
        let addon = resolveLicenseAddon(plan);

        confirmAlert({
            title: 'Subscribe to Roam',
            message: 'Select a Roam plan.',
            submitting,
            closeOnEscape: false,
            closeOnClickOutside: false,
            customUI: ({ onClose }) => (
                <ConfirmNewPlanAlert
                    currentRoam={props.currentRoam}
                    newPlanId={plan.id}
                    plan={plan}
                    addon={addon}
                    onClose={onClose}
                    onSubmit={() => handleSubscribe(value)}
                />
            ),
        });
    };

    useEffect(() => {
        props.requestRoamPlans();
        props.requestAddons();
        props.requestCoupons();
    }, []);

    const handleSubscribe = (value) => {
        setSubmitting(true);
        console.log(value);
        console.log(get(values));
        return props
            .swapSubscription(props.roamSubscriptionId, value)
            .then((s) =>
                props.successNotice(
                    'Your Roam subscription will be updated at the end of the current billing period.',
                ),
            )
            .then(() => props.afterSuccess && props.afterSuccess())
            .finally(() => setSubmitting(false));
    };

    const handleSubmit = (value) => {
        setSubmitting(true);
        return props
            .swapSubscription(props.roamSubscriptionId, value)
            .then((s) =>
                props.successNotice(
                    'Your Roam subscription will be updated at the end of the current billing period.',
                ),
            )
            .then(() => props.afterSuccess && props.afterSuccess())
            .finally(() => setSubmitting(false));
    };

    const newPlanSubscription = (planId) => {
        cb.openCheckout({
            hostedPage: () => cscom.hostedPage().newPlanSubscription(planId),
            error: (e) => console.log(e),
            //close: () => { window.location.reload(); },
            success: () => {
                props.requestCurrentRoam();
                props.successNotice('Your Roam subscription has been created.');
                page.redirect('/dashboard/roam');
            },
        });
    };

    const resolveLicenseAddon = (plan) => {
        return null;
    };

    if (props.requesting) {
        return <Loader />;
    }

    return (
        <form onSubmit={handleSubmit}>
            <Box>
                <Stack space='xxlarge'>
                    {roamPlans.map((plan, i) => {
                        return (
                                <Plan
                                key={plan.id}
                                plan={plan}
                                onClick={() => onChange(plan.id)}
                                disabled={
                                    !(props.currentRoam && props.currentRoam.status == 'cancelled')
                                        ? plan.id == props.roamPlanId
                                        : null
                                }
                                licenseAddon={resolveLicenseAddon(plan)}
                                numberLicenses={props.currentUser.additionalLicenses}
                            />
                        );
                    })}
                </Stack>
            </Box>
        </form>
    );
};

export default connect(
    (state) => ({
        roamPlans: getAllRoamPlans(state),
        addons: getAllAddons(state),
        roamSubscriptionId: getCurrentRoamId(state),
        roamPlanId: getCurrentRoamPlanId(state),
        currentRoam: getCurrentRoam(state),
        currentUser: getCurrentUser(state),
        requesting: requestingRoamPlans(state),
    }),
    {
        requestRoamPlans: requestPlansIfNotRequested,
        requestCurrentRoam,
        requestCoupons: requestCouponsIfNotRequested,
        swapSubscription,
        successNotice,
        requestAddons: requestAddonsIfNotRequested,
    },
)(SelectRoamPlan);
